import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import NotFound from "@/pages/NotFound";
import ClientDashboard from "@/pages/client/ClientDashboard";
import ClientProfile from "@/pages/client/ClientProfile";
import ClientDemat from "@/pages/client/ClientDemat";
import ClientOrders from "@/pages/client/ClientOrders";
import ClientKyc from "@/pages/client/ClientKyc";
import ClientNotifications from "@/pages/client/ClientNotifications";
import ClientDocuments from "@/pages/client/ClientDocuments";
import ClientSection from "@/pages/client/ClientSection";
import ClientSupport from "@/pages/client/ClientSupport";
import ClientComingSoon from "@/pages/client/ClientComingSoon";
import { BottomTabBar } from "@/components/BottomTabBar";
import { AssistantWidget } from "@/components/AssistantWidget";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import CompanyDetail from "@/pages/CompanyDetail";
import ArticleDetail from "@/pages/ArticleDetail";
import AuthPage from "@/pages/AuthPage";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function AppRoutes() {
  const location = useLocation();
  // Process Google OAuth callback FIRST (synchronously during render) to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/company/:slug" element={<CompanyDetail />} />
        <Route path="/insights/:slug" element={<ArticleDetail />} />
        <Route path="/client/login" element={<AuthPage />} />
        <Route path="/client/register" element={<AuthPage />} />
        <Route path="/client/forgot-password" element={<AuthPage />} />
        <Route path="/client" element={<Navigate to="/client/dashboard" replace />} />
        <Route path="/client/dashboard" element={<ClientDashboard />} />
        <Route path="/client/profile" element={<ClientProfile />} />
        <Route path="/client/demat" element={<ClientDemat />} />
        <Route path="/client/orders" element={<ClientOrders />} />
        <Route path="/client/kyc" element={<ClientKyc />} />
        <Route path="/client/notifications" element={<ClientNotifications />} />
        <Route path="/client/documents" element={<ClientDocuments />} />
        <Route path="/client/support" element={<ClientSupport />} />
        <Route path="/client/portfolio" element={<ClientSection kind="portfolio" />} />
        <Route path="/client/alerts" element={<ClientSection kind="alerts" />} />
        <Route path="/client/consult" element={<ClientSection kind="consult" />} />
        <Route path="/client/enquiries" element={<ClientSection kind="enquiries" />} />
        <Route path="/client/:module" element={<ClientComingSoon />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/account" element={<Account />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<Admin />} />
        <Route
          path="/insights"
          element={<Navigate to="/#insights" replace />}
        />
        <Route
          path="/opportunities"
          element={<Navigate to="/#opportunities" replace />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomTabBar />
      {!location.pathname.startsWith("/admin") && <AssistantWidget />}
    </>
  );
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FFFFFF] text-slate-900">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#F6F4FD",
            border: "1px solid rgba(109, 40, 217,0.3)",
            color: "#0F172A",
          },
        }}
      />
    </div>
  );
}

export default App;
